import React from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
} from "react-router-dom";
import Login from "../../src/pages/Login";
import Dashboard from "../../src/pages/Dashboard";
import SetAvailability from "../../src/pages/Availability";
import Calender from "../../src/pages/Calender";
import Profile from "../pages/Profile";
import UpcomingAppoinment from "../pages/UpcomingAppoinment";
import AppoinmentHistory from "../pages/AppoinmentHistory";
import StudentVideo from "../pages/Student/Video";
import SessionSummary from "../pages/SessionSummary/index";
import Logout from "../pages/Logout/index";
import Call from "../pages/Call";
import Chat from "../pages/Chat";
import UpdateProfile from "../pages/UpdateProfile";
import UserRisk from "../pages/UserRisk";
import Inperson from "../pages/InPerson";
import Test from "../pages/Test";
import Header from "../Component/TopBar";
import AppointmentDetail from "../pages/AppointmentDetail";
import Events from "../pages/Events";
import AgoraRTC, { AgoraRTCProvider } from "agora-rtc-react";
import CreateEvent from "../pages/CreateEvent";
import Support from "../pages/Support";
import HelpCenter from "../pages/HelpCenter";
import MemberSummaryReport from "../pages/MemberSummaryReport";
import { trackPageView } from "../utils/analytics";
// Declare Channel component at module scope, not inside Layout
const Channel = () => {
  const client = React.useMemo(
    () => AgoraRTC.createClient({ mode: "rtc", codec: "vp8" }),
    []
  );

  return (
    <AgoraRTCProvider client={client}>
      <Call />
    </AgoraRTCProvider>
  );
};

const InCallChannel = () => {
  const client = React.useMemo(
    () => AgoraRTC.createClient({ mode: "rtc", codec: "vp8" }),
    []
  );

  return (
    <AgoraRTCProvider client={client}>
      <Inperson />
    </AgoraRTCProvider>
  );
};

function Layout() {
  const location = useLocation();

  // GA page view per route change; analytics.js sends the route pattern only.
  React.useEffect(() => {
    trackPageView(location.pathname);
  }, [location.pathname]);

  // Don't show header on login page and member summary report page
  const hideHeaderRoutes = ["/"];
  const hideHeaderRoutePatterns = ["/member-summary-report"];
  
  const shouldShowHeader = !hideHeaderRoutes.includes(location.pathname) && 
                          !hideHeaderRoutePatterns.some(pattern => location.pathname.startsWith(pattern));

  return (
    <>
      {shouldShowHeader && <Header />}
      <Routes>
        <Route path="/" element={<Login />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/call/:channel/:mode/:id/:uid" element={<Channel />} />
        <Route
          path="/set-availability/:available"
          element={<SetAvailability />}
        />
        <Route path="/calendar" element={<Calender />} />
        <Route path="/profile" element={<Profile />} />
        <Route path="/events" element={<Events />} />
        <Route
          path="/appointment-detail/:aid/:uid"
          element={<AppointmentDetail />}
        />
        <Route
          path="/upcoming-appointments/:upcoming"
          element={<UpcomingAppoinment />}
        />
        <Route path="/createEvent" element={<CreateEvent />} />
        <Route path="/report" element={<CreateEvent />} />
        <Route
          path="/upcoming-appointments/:upcoming"
          element={<UpcomingAppoinment />}
        />
        <Route path="/appointment-history" element={<AppoinmentHistory />} />
        <Route path="/session-summary" element={<Dashboard />} />
        <Route
          path="/studentVideo/:show/:id/:channel"
          element={<StudentVideo />}
        />

        <Route
          path="/inPerson/:channel/:mode/:id/:uid/:title/:firstName/:lastName/:date/:startTime"
          element={<InCallChannel />}
        />
        <Route path="/chat/:channel/:mode/:id/:uid" element={<Chat />} />
        <Route path="/logout" element={<Logout />} />
        <Route path="/updateProfile" element={<UpdateProfile />} />
        <Route path="/user-risk" element={<UserRisk />} />
        <Route path="/help_center" element={<HelpCenter />} />
        <Route path="/support" element={<Support />} />
        <Route path="/member-summary-report/:aid/:uid" element={<MemberSummaryReport />} />
        {/* <Route path="/test" element={<Test />} /> */}
      </Routes>
    </>
  );
}

export default function Index() {
  return (
    <Router basename={process.env.REACT_APP_HOMEPAGE}>
      <Layout />
    </Router>
  );
}
